import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import Terms from '@/modules/legal/Terms'
import { Stack } from 'expo-router'
import { ScrollView } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function TermsPage() {
  const headerLeftItems = useWebBackButton('/forms')
  const insets = useSafeAreaInsets()

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <ScrollView
        contentInsetAdjustmentBehavior="automatic"
        contentContainerStyle={{ paddingBottom: insets.bottom }}
      >
        <Terms />
      </ScrollView>
    </>
  )
}
